import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "../../lib/utils"
import { useTheme } from "../../styles/ThemeProvider"

const Label = React.forwardRef(({ className, ...props }, ref) => {
  const { themeObject } = useTheme();
  
  // Obtener tokens del tema actual
  const labelTokens = themeObject.components.label || {};
  
  const labelStyles = {
    fontSize: labelTokens.fontSize || themeObject.typography?.fontSize?.sm || '14px',
    fontWeight: labelTokens.fontWeight || themeObject.typography?.fontWeight?.medium || '500',
    lineHeight: labelTokens.lineHeight || themeObject.typography?.lineHeight?.none || '1',
    color: labelTokens.color || themeObject.colors.text.primary,
    cursor: 'default',
  };

  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      style={labelStyles}
      {...props}
    />
  );
})
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
